import React, { useState, useEffect, useContext } from "react";

import { Paper } from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useStyles } from "./style";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";

import {
  EnhancedTableToolbar,
  CardItem,
} from "../../../components/pages/reports/creditNoteReport/index";

// ✅ CHANGE CONTEXT
import { CreditNoteReportContext } from "../../../context/states/reports/creditNoteReportState";

const initialState = {
  isSearch: false,
  companyId: "",
  company: "",
  fromDate: null,
  toDate: null,
  businessType: "",
};

const CreditNoteReport = () => {
  const classes = useStyles();
  const matches = useMediaQuery("(min-width:1920px)");

  const {
    creditNotes,
    totalAmount,
    totalVAT,
    totalCredit,
    clients,
    count,
    loading,
    getClientsHandler,
    getCreditNoteReportHandler,
    clearCreditNoteStateHandler,
  } = useContext(CreditNoteReportContext);

  const [values, setValues] = useState({ ...initialState });
  const [dense] = useState(true);

  useEffect(() => {
    getCreditNoteReportHandler("");
  }, []);

  // ✅ Handle Inputs
  const handleChange = (event) => {
    const { name, checked, value, type } = event.target;

    setValues((prev) => ({
      ...prev,
      [name]:
        name === "businessType"
          ? checked
            ? "Private"
            : ""
          : type === "checkbox"
            ? checked
            : value,
    }));
  };

  const handleChangeAutoComplete = (name) => (event, value) => {
    if (value === null) {
      setValues({ ...initialState });
      clearCreditNoteStateHandler();
      return;
    }
    if (name === "company") {
      setValues({ ...values, [name]: value, companyId: value._id });
    }
  };

  const handleInputChange = (event) => {
    if (event.target.value === "") return;
    getClientsHandler(event.target.value);
  };

  const handleFromDateChange = (event) => {
    const date = new Date(event).toISOString();
    setValues({ ...values, fromDate: date });
  };

  const handleToDateChange = (event) => {
    const date = new Date(event).toISOString();
    setValues({ ...values, toDate: date });
  };

  // ✅ SEARCH
  const searchHandler = () => {
    let query = "";

    if (values.companyId !== "") {
      query += `companyId=${values.companyId}`;
    }

    if (values.businessType !== "") {
      query += `${query.length > 0 ? "&" : ""}businessType=${values.businessType}`;
    }

    let filteredDate = "";

    if (values.fromDate) {
      filteredDate = `&fromDate=${values.fromDate}`;
      if (values.toDate) {
        filteredDate += `&toDate=${values.toDate}`;
      }
    }

    getCreditNoteReportHandler(`${query}${filteredDate}`);
  };

  const clearSearchHandler = () => {
    setValues({ ...initialState });
    getCreditNoteReportHandler("");
  };

  return (
    <React.Fragment>
      <div style={{ width: "100%" }}>
        <Paper className={classes.paper}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <EnhancedTableToolbar
              handleChange={handleChange}
              values={values}
              isClients={clients}
              handleInputChange={handleInputChange}
              handleChangeAutoComplete={handleChangeAutoComplete}
              // ✅ UPDATED TOTALS
              count={count}
              totalAmount={totalAmount}
              totalVAT={totalVAT}
              totalCredit={totalCredit}
              title={"Credit Note Report"}
              handleFromDateChange={handleFromDateChange}
              handleToDateChange={handleToDateChange}
              searchHandler={searchHandler}
              clearSearchHandler={clearSearchHandler}
            />
          </MuiPickersUtilsProvider>

          <CardItem
            values={values}
            hasData={creditNotes && creditNotes.length > 0}
            title="Credit Note Report"
            active={classes.paidStage}
            classes={classes}
            isLoading={loading}
            data={creditNotes}
            dense={dense}
            matches={matches}
          />
        </Paper>
      </div>
    </React.Fragment>
  );
};

export default CreditNoteReport;
